<template>
    <div class="home" style="height: calc(100vh - 132px);" ref="appContainer" v-loading="loading">
        <div class="d-b-c">
            <div class="operation-wrap">
                <el-row :gutter="20">
                    <el-col :span="12" :offset="6" class="d-c-c">
                        <div class="sign">
                            <div class="title">
                                <span class="title-icon icon iconfont menu-item-icon icon-zhuanyemingcheng"></span>
                                <span>附件材料</span>
                            </div>
                            <div class="content">
                                <el-table
                                    :data="tableData"
                                    stripe
                                    :header-cell-style="{
                                        'color': '#000'
                                    }"
                                    style="width: 100%;color: black;background-color: #eee">
                                    <el-table-column
                                            prop="real_name"
                                            label="附件名称">
                                    </el-table-column>
                                    <el-table-column
                                            prop="address"
                                            label="操作"
                                            align="right">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" @click="download(scope.row)">下载</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import IndexApi from '@/api/index.js';

    export default {
        data() {
            return {
                loading: true,
                tableData: [],
            };
        },
        created() {
            // 获取数据
            this.getData();
        },
        methods: {
            // 获取数据
            getData() {
                let that = this;

                IndexApi.getFileList(true).then(res => {
                    that.tableData = res.data.list.data
                    that.loading = false;
                }).catch(error => {

                });
            },

            // 下载附件材料
            download(row){
                window.open(row.file_path,'_self');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .operation-wrap {
        width: 100%;
        border-radius: 8px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        overflow: unset;
        background: #fff;
        background-size: 100% 100%;
        color: #FFFFFF;
        margin-bottom: 20px;
        .sign{
            width: 100%;
            min-height: 500px;
            background-color: #eee;
            border-radius: 15px;
            .title{
                height: 60px;
                width: 100%;
                background-color: #409eff;
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: bold;
                color: #fff;
                padding-left: 20px;
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;
                .title-icon{
                    font-size: 32px;
                    margin-right: 10px;
                }
            }
            .content{
                padding: 15px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/home/file.vue